export default function getDomainListPathFromTagReduxUtil (domainListPath, tag) {
  if (!tag) {
    return domainListPath
  }
  return `${domainListPath}.byTag.${tag}`
}
